<div class="pageHeader">
    <h1 class="pageHeading" style="margin-bottom: 32px; margin-top: 88px; text-align: center;">YGC Greenscapes<span style=" color: #828282;"> &</span> YourOwnROOM</h1>
    <div class="row " style="padding: 32px 40px">
        
        <div class="col-md-6 col-12 header">
            <div>
                <p class="contentSubText">YGC Greenscapes, Co-Founded by Babita Sinha and Saumya Tiwary  and YourOwnROOM, Co-Founded by Prabhat Kumar Tiwary (Stanford GSB, BIT Mesra) have signed a multi year partnership.YGC is a customer centric design led company that offers Landscaping solutions to offices and homes. YourOwnROOM will offer its property and project management services in planning and executing projects involving Fabrication, Civil Work, Painting and Electrical Work. This partnership will enable YGC scale their Business in Bangalore.
                    So far the 2 companies have worked on over 25 Projects in Bangalore for Villas and Apartments in premium societies like Address Maker, Adarsh Palm Retreat, Nambiar Elleganza and Nambiar Bellezea, Total Environment, Salarpuria Magnifisia, 42 Queen’s Square and YGC Experience Center.</p>
            </div>
        </div>
        <div class="col-md-6 col-12" style="margin-bottom: 24px;">
            <img src="../../../assets/images/ygcproject.jpg" class="img-responsive" style="width: 100%;"/>
        </div>
    </div>
</div>

<div class="pageWrapper" style="margin: 64px 0px">
    <div class="service-htw-wrapper" style="margin: 64px 0px 88px 0px; padding: 0px 40px;">
        <div style="display: flex; justify-content: center; align-items: flex-start; flex-direction: column; row-gap: 12px; margin-bottom: 24px;">
            <p class="sectionHeader" style="color: #828282;">Successful</p>
            <p class="sectionHeader" style="font-weight: 600;margin-top: 8px">Projects</p>
        </div>
        <div class="row  justify-content-center">
            <!-- Project 1 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 completed_projects">
                <div class="project-img-wrapper">
                    <img src="assets/images/completed projects/ECITY/After/EC_CP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                </div>
                <h2 class="project-desp">5,000 sq.ft. Pergola installation and civil work and painting for premium villa at Address Maker.
                    <br>
                    <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                    Electronic City, Banglore.
                </h2>
                <div class="catalogue-underline"></div>
                <p class="view_project_img" data-toggle="modal" data-target="#EcModal">View all images</p>
            </div>
            <!-- Project 2 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 completed_projects offset-lg-1 offset-md-1 offset-sm-0">
                <div>
                    <div class="project-img-wrapper" style="justify-content: space-evenly;">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP3.png" alt="YourOwnROOM - Projects" class="img-responsive project-img"  >
                    </div>
                    <h2 class="project-desp">
                        2,000 sqft Pergola installation and civil work and painting for a premium villa at Address Maker.
                        <br> 
                        <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                        Sarjapur, Bangalore.
                    </h2>
                    <div class="catalogue-underline"></div>
                </div>
                <div>
                    <p class="view_project_img" data-toggle="modal" data-target="#SpModal">View all images</p>
                </div>
            </div>
            <!-- Project 3 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0 completed_projects">
                <div class="project-img-wrapper">
                    <img src="assets/images/completed projects/HSR/ECenter1.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                </div>
                <h2 class="project-desp">Building terrace garden experience centre across 1000 sqft for a premium interior company
                    <br>
                    <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                    HSR Layout, Banglore.
                </h2>
                <div class="catalogue-underline"></div>
                <p class="view_project_img" data-toggle="modal" data-target="#HSRModal">View all images</p>
            </div>
            <!-- Project 4 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 offset-xl-0 offset-lg-1 offset-md-1 offset-sm-0 completed_projects">
                <div>
                    <div class="project-img-wrapper">
                        <img src="assets/images/completed projects/MITS/MITS1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                    </div>
                    <h2 class="project-desp">1,000 sqft Pergola installation and civil work and painting for Nambiar Villa.
                        <br>
                        <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                        Sarjapur, Banglore.
                    </h2>
                    <div class="catalogue-underline"></div>
                </div>
                <div>
                    <p class="view_project_img" data-toggle="modal" data-target="#MITSModal">View all images</p>
                </div>
                
                
            </div>
            <!-- Project 5 -->
            <div class="col-xl-3 col-lg-4 col-md-5 col-sm-7 col-10 offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0 completed_projects">
                <div>
                    <div class="project-img-wrapper">
                        <img src="assets/images/completed projects/APR/APR2.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-img"  >
                    </div>
                    <h2 class="project-desp">2,000 sqft Pergola installation and civil work and painting in Adarsh Palm Retreat Villa.
                        <br>
                        <fa-icon [icon]="faMapPin" style="color: salmon" class="fa-sm" ></fa-icon>
                        Sarjapur, Banglore.
                    </h2>
                    <div class="catalogue-underline"></div>
                </div>
                <div>
                    <p class="view_project_img" data-toggle="modal" data-target="#APRModal">View all images</p>
                </div>
            </div> 
        </div>
    </div>
    <div class="row" style="margin: 32px 0px; padding: 0px 40px">
        <div class="col-md-2 col-12">
                <div  style="margin-bottom: 16px; ">
                    <img src="../../../assets/images/ygc_babita.jpeg" style="width: 196px; height: 196px;">
                </div>
        </div>
        <div class="col-md-10 col-12" style="display: flex; align-items: center; justify-content: center;">
            <div class="memberQuotes" style=" width: 100%;">
                “YourOwnROOM is one of our critical Execution arm and help us in Proposal and Quote Creation, Project Planning and project Execution. They do a very professional job across multiple services related to out door projects like Pergola Installations, Civil Work, Carpentry and Painting.”<br> - Babita Sinha, CEO & Co-Founder, YGC Greenscapes.
            </div>
        </div>
        
    </div>
    <div class="row" style="margin: 32px 0px; padding: 0px 40px">
        
        <div class="col-md-10 col-12" style="display: flex; align-items: center; justify-content: center;">
            <div class="memberQuotes" style=" width: 100%;">
                “I am amazed at the Design capabilities of YGC Greenscapes. They are able to create magic from a totally empty canvas. YourOwnROOM is thrilled to have partnered with YGC and expected several project for the last 2 years and look forward to this partnership.”<br> - Sanjay Singh, COO & CTO, YourOwnROOM.
            </div>
        </div>
        <div class="col-md-2 col-12">
            <div  style="margin-bottom: 16px; ">
                <img src="../../../assets/images/sanjay_latest_yor.jpeg" style="width: 196px; height: 196px;">
            </div>
    </div>
    </div>
    

    
</div>

<div class="modal fade" id="SpModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <h2>Before : </h2>
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/Before/SP_BCP1.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/Before/SP_BCP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/Before/SP_BCP3.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    
                </div>
                <h2 style="margin-top: 16px;">After : </h2>
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP1.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP3.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                    <div class="col-lg-4" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/Sarjapur/After/SP_CP4.png" alt="YourOwnROOM - Projects" class="img-responsive  project2-slide-images"  >
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="EcModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <h2>Before : </h2>
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/Before/EC_BCP1.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/Before/EC_BCP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/Before/EC_BCP3.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    
                </div>
                <h2 style="margin-top: 16px;">After : </h2>
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/After/EC_CP1.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/After/EC_CP2.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/ECITY/After/EC_CP3.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/ECITY/After/EC_CP4.png" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="HSRModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-4">
                        <img src="assets/images/completed projects/HSR/ECenter1.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4" >
                        <img src="assets/images/completed projects/HSR/ECenter2.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-4" >
                        <img src="assets/images/completed projects/HSR/ECenter4.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-6" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/HSR/ECenter3.jpeg" alt="YourOwnROOM - Projects" class="img-responsive  project3-slide-images"  >
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="MITSModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/MITS/MITS1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" >
                        <img src="assets/images/completed projects/MITS/MITS3.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/MITS/MITS4.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/MITS/MITS6.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-6" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/MITS/MITS5.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="APRModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/APR/APR1.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" >
                        <img src="assets/images/completed projects/APR/APR2.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/APR/APR3.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3">
                        <img src="assets/images/completed projects/APR/APR4.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR5.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR6.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR7.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR8.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    <div class="col-lg-3" style="margin-top: 16px;">
                        <img src="assets/images/completed projects/APR/APR9.jpg" alt="YourOwnROOM - Projects" class="img-responsive  project-slide-images"  >
                    </div>
                    
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>